import BaseType from "../BaseType";
import SiteResponseItem from "./SiteResponseItem";

export default class SiteResponseHeader extends BaseType {
  Items: SiteResponseItem[] = [];
}
